// Item só para visualização (D-0113, Rafael 26/10): o operador põe opções de um item para o cliente escolher e
// desmarca "Somar no valor total" nas que não valem. A linha mostra o valor dela (unitário × diárias ×
// quantidade) na tela e no Excel, mas não soma em nada (subtotal, total, FEE, imposto) e não vai para o
// financeiro. Espelho de accessapi app/Services/OrcamentoSomenteVisualizacao.php.
//
// Campo `somenteVisualizacao` (padrão false = soma): linha sem o campo (legado) continua somando. A caixa da
// tela é o inverso: marcada = soma.
export const CAMPO_SOMENTE_VISUALIZACAO = 'somenteVisualizacao';

export const ehSomenteVisualizacao = (linha) => {
    const valor = linha?.[CAMPO_SOMENTE_VISUALIZACAO];
    if (typeof valor === 'boolean') return valor;
    if (typeof valor === 'number') return valor === 1;
    return ['1', 'true', 'sim', 'yes', 'on'].includes(String(valor ?? '').trim().toLowerCase());
};
